import { createEventProperties, addEventProperties, createTData, getEventSvcProperties } from '../../../interfaces/traffic/eventProperties';
import AbstractEventHandler from '../../csp/handlers/abstractEventHandler';

import { sendEvent } from '@tcc/shared/src/integrations/eventService/eventService';
import { merge } from '@exp/exp-utils/helper/object';
import config from '@exp/exp-utils/helper/config';
import { filterPerfSchemas, filterPerfDelayedSchemas } from '../../../utils/eventBusUtils';

class AddPerfHandler extends AbstractEventHandler {

  process() {
    super.process({
      EVENT_SVC: () => { this._handleEventSvc(); }
    });
  }

  _getApiKey() {
    return config.get('tcc.eventBusRigorApiKey');
  }

  _handleEventSvc() {
    sendEvent(
      merge(this.pageEvent.getProperties(), getEventSvcProperties()),
      '/b.aspx');
  }

  _getEvents(input) {
    if (input.properties && input.properties.navigationStart) {
      return [{
        schemaId: 'urn:shared:user:event:/rigor/page-view-load/v1',
        data: filterPerfSchemas(input.properties)
      }];
    }
    if (input.properties && input.properties.timeToInteractive) {
      return [{
        schemaId: 'urn:shared:user:event:/rigor/page-view-load-delayed/v1',
        data: filterPerfDelayedSchemas(input.properties)
      }];
    }
  }

  preProcess() {
    this.pageEvent = createEventProperties('page.log', createTData(this.data));

    addEventProperties(this.pageEvent, this.data.ALL.type);

    // Hard vs Soft navigation (normal page request vs virtual page request)
    this.pageEvent.set('nav_type', this.data.ALL.nav_type);

    // This handler is reused by multiple perf interfaces and is kept
    // around for legacy functionality (primarily SPAs)
    if (typeof this.data.ALL.properties === 'object') {
      this.pageEvent.merge(this.data.ALL.properties);
    }

    // Merge datalayer extras, which includes an identifier to
    // correlate the hit between downstream systems (hit_id)
    this.pageEvent.merge(this.extras);
  }
}

export default AddPerfHandler;
